'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _index = require('../../utils/index');

var _index2 = _interopRequireDefault(_index);

var _proGalleryLayouter = require('pro-gallery-layouter');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _watermarkApi = require('photography-client-lib/dist/src/store/watermarkApi');

var _watermarkApi2 = _interopRequireDefault(_watermarkApi);

var _imageClientSDK = require('image-client-api/dist/imageClientSDK');

var imageSdk = _interopRequireWildcard(_imageClientSDK);

var _windowWrapper = require('photography-client-lib/dist/src/sdk/windowWrapper');

var _windowWrapper2 = _interopRequireDefault(_windowWrapper);

var _experimentsWrapper = require('photography-client-lib/dist/src/sdk/experimentsWrapper');

var _experimentsWrapper2 = _interopRequireDefault(_experimentsWrapper);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GalleryItem = function () {
  function GalleryItem(config) {
    var _this = this;

    (0, _classCallCheck3.default)(this, GalleryItem);


    this.uniqueId = _index2.default.generateUUID();
    this.isGalleryItem = true;
    this.createdBy = config.createdBy;

    if (config.dto && config.dto.dto) {
      config.dto = config.dto.dto; //defence patch due to mis-use of item-core
      if (_index2.default.isDev()) {
        console.warn('Item core is created with already existing item core');
      }
    }
    this.dto = _lodash2.default.merge({}, config.dto);
    _lodash2.default.merge(this, config.dto);

    if (config.scheme) {
      this.processScheme(config.scheme);
    } else {
      var dto = {};
      (0, _assign2.default)(dto, this.dto, this.metadata);
      this.processScheme(new _proGalleryLayouter.Item({ dto: dto }).scheme);
    }
    if (config.wixImage && _lodash2.default.isNumber(config.orderIndex)) {
      this.createFromWixImage(config.wixImage, config.orderIndex, config.addWithTitles, config.isSecure);
    }

    if (config.wixVideo && _lodash2.default.isNumber(config.orderIndex)) {
      this.createFromWixVideo(config.wixVideo, config.orderIndex, config.addWithTitles, config.isSecure);
    }
    if (config.wixExternal && _lodash2.default.isNumber(config.orderIndex)) {
      this.createFromExternal(config.wixExternal, config.orderIndex, config.addWithTitles, config.isSecure);
    }

    if (this.dto) {
      var itemMetadata = this.dto.metaData || this.dto.metadata;
      if (itemMetadata) {
        //metadata is encoded encoded, parsed if needed
        this.dto.metaData = _index2.default.parseStringObject(itemMetadata);
      }
    }
    if (_index2.default.isStoreGallery() && !this.isVideo) {
      this.watermark = config.watermark;
      if (!this.watermark) {
        _watermarkApi2.default.getWatermarkData() //this request should be sync (the watermark should have been cached by the gallery or the fullscreen)
        .then(function (data) {
          _this.watermark = data;
          _this.watermarkStrSdk = _this.watermark && _this.watermark.imageUrl ? _this.watermark.imageUrl + '-' + _this.watermark.opacity + '-' + _this.watermark.position + '-' + _this.watermark.size : '';
          _this.watermarkStr = _this.watermark && _this.watermark.imageUrl ? ',wm_' + _this.watermarkStrSdk : '';
        });
      } else {
        // protect against watermark being a string - it happens some times.
        if (typeof this.watermark === 'string') {
          try {
            this.watermark = JSON.parse(this.watermark);
          } catch (error) {
            console.error('item-core - given watermark (' + this.watermark + ') is not an object', error);
          }
        }
        this.watermarkStr = '';
        if (this.watermark.imageUrl) {
          this.watermarkStrSdk = this.watermark.imageUrl + '-' + this.watermark.opacity + '-' + this.watermark.position + '-' + this.watermark.size;
          this.watermarkStr = ',wm_' + this.watermarkStrSdk;
        }
      }
    }

    this.sharpParams = _lodash2.default.merge({}, config.sharpParams);
    if (!this.sharpParams.quality) {
      this.sharpParams.quality = 90;
    }
    if (!this.sharpParams.usm) {
      this.sharpParams.usm = {};
    }
    this.updateSharpParams();

    this.createUrls();
  }

  (0, _createClass3.default)(GalleryItem, [{
    key: 'processScheme',
    value: function processScheme(scheme) {
      this.id = scheme.id;
      this.idx = scheme.idx;
      this.type = scheme.type;
      this.style = scheme.style;
      this.width = scheme.width;
      this.maxWidth = scheme.maxWidth;
      this.height = scheme.height;
      this.maxHeight = scheme.maxHeight;
      this.margins = scheme.margins;
      this.ratio = scheme.ratio;
      this.cubeRatio = scheme.cropRatio;
      this.cubeImages = scheme.isCropped;
      this.cubeType = scheme.cropType || 'fill';
      this.offset = scheme.offset;
      this.group = scheme.group;
      this.transform = scheme.transform;
      this.orientation = scheme.orientation;
      this.visibility = scheme.visibility;
    }
  }, {
    key: 'renderProps',
    value: function renderProps(config) {

      return _lodash2.default.merge({
        className: 'image',
        key: this.key,
        idx: this.idx,
        photoId: this.photoId,
        id: this.id,
        hash: this.id,
        html: this.html,
        type: this.type,
        url: this.url,
        alt: this.alt,
        directLink: this.directLink,
        linkUrl: this.linkUrl,
        linkOpenType: this.linkOpenType,
        originalsUrl: this.getOriginalsUrl(),
        title: this.title,
        fileName: this.fileName,
        description: this.description,
        full_url: this.full_url,
        download_url: this.download_url,
        sample_url: this.sample_url,
        preload_url: this.preload_url,
        square_url: this.square_url,
        pixel_url: this.pixel_url,
        resized_url: this.resized_url,
        thumbnail_url: this.thumbnail_url,
        cubeImages: this.cubeImages,
        cubeType: this.cubeType,
        cubeRatio: this.cubeRatio,
        transform: this.transform,
        offset: this.offset,
        style: _lodash2.default.merge({
          bgColor: this.bgColor,
          maxWidth: this.maxWidth,
          maxHeight: this.maxHeight,
          ratio: this.ratio,
          orientation: this.orientation
        }, this.style),
        isDemo: this.isDemo,
        videoUrl: this.videoUrl,
        isExternalVideo: this.isExternalVideo,
        scroll: config.scroll,
        visible: config.visible,
        styleParams: config.styleParams,
        actions: config.actions,
        currentIdx: config.currentIdx,
        currentHover: config.currentHover
      }, config);
    }
  }, {
    key: 'getDataForShop',
    value: function getDataForShop() {
      var focalPoint = this.focalPoint;
      var metadata = this.metadata;
      return {
        isDemo: metadata.isDemo,
        orderIndex: this.orderIndex,
        itemId: this.dto.itemId,
        originalUrl: this.getOriginalsUrl(),
        itemUrl: this.url,
        itemHeight: metadata.height,
        title: metadata.title,
        itemWidth: metadata.width,
        itemType: metadata.type || 'image',
        imageUrl: this.resizedUrl('fit', 200, 200, null, null).img,
        imagePurchasedUrl: this.dto.mediaUrl,
        fpX: focalPoint[0],
        fpY: focalPoint[1]
      };
    }
  }, {
    key: 'createFromWixImage',
    value: function createFromWixImage(wixData, orderIndex, addWithTitles, isSecure) {
      var url = wixData.uri || wixData.relativeUri || wixData.url;
      var itemId = url.slice(0, url.length - 4);
      var metadata = {
        createdOn: new Date().getTime(),
        height: wixData.height,
        width: wixData.width,
        lastModified: new Date().getTime(),
        focalPoint: wixData.focalPoint,
        name: wixData.fileName,
        fileName: wixData.title,
        title: '',
        type: wixData.type,
        link: this.initialLinkObject,
        sourceName: wixData.sourceName,
        tags: wixData.tags,
        wm: wixData.wm
        // title: wixData.title || '',
        // description: wixData.description || '',
      };

      if (addWithTitles) {
        metadata.title = wixData.title;
      }

      this.dto = { itemId: itemId, mediaUrl: url, orderIndex: orderIndex, metadata: metadata, isSecure: isSecure };
    }
  }, {
    key: 'createFromWixVideo',
    value: function createFromWixVideo(wixData, orderIndex, addWithTitles, isSecure) {

      var qualities = _lodash2.default.map(wixData.fileOutput.video, function (q) {
        return {
          height: q.height,
          width: q.width,
          quality: q.quality,
          formats: [q.format]
        };
      });

      var posters = _lodash2.default.map(wixData.fileOutput.image, _lodash2.default.partialRight(_lodash2.default.pick, ['url', 'width', 'height']));
      posters = _lodash2.default.map(posters, function (p) {
        p.url = p.url.replace('media/', '');
        return p;
      });
      var resolution = this.getHighestMp4Resolution(qualities);
      var metaData = {
        createdOn: new Date().getTime(),
        name: wixData.title,
        lastModified: new Date().getTime(),
        width: resolution.width,
        height: resolution.height,
        type: 'video',
        posters: posters,
        customPoster: '',
        isExternal: false,
        duration: wixData.fileInput.duration,
        qualities: qualities,
        link: this.initialLinkObject
        // title: wixData.title,
        // description: wixData.description,
      };

      if (addWithTitles) {
        metaData.title = wixData.title;
      }

      var mediaUrl = wixData.fileBaseUrl.replace('video/', '');
      this.dto = { itemId: wixData.id, mediaUrl: mediaUrl, orderIndex: orderIndex, metaData: metaData, isSecure: isSecure };
    }
  }, {
    key: 'getHighestMp4Resolution',
    value: function getHighestMp4Resolution(qualities) {
      var mp4s = qualities.filter(function (video) {
        return video.formats[0] === 'mp4';
      });
      var _mp4s$sort$ = mp4s.sort(function (a, b) {
        return b.width - a.width;
      })[0],
          width = _mp4s$sort$.width,
          height = _mp4s$sort$.height;

      return { width: width, height: height };
    }
  }, {
    key: 'createFromExternal',
    value: function createFromExternal(wixData, orderIndex, addWithTitles, isSecure) {
      var metaData = {
        createdOn: new Date().getTime(),
        name: wixData.id,
        videoId: wixData.id,
        lastModified: new Date().getTime(),
        height: 1080,
        width: 1920,
        source: wixData.source || '',
        videoUrl: wixData.videoUrl || '',
        isExternal: true,
        type: 'video',
        posters: wixData.posters,
        customPoster: '',
        duration: 0,
        qualities: []
      };

      this.dto = { itemId: wixData.id, mediaUrl: metaData.posters[0].url, orderIndex: orderIndex, metaData: metaData, isSecure: isSecure };
    }
  }, {
    key: 'useImageClientApi',
    value: function useImageClientApi() {
      var isSdkExperimentOn = !(_experimentsWrapper2.default['specs.pro-gallery.ImageClientApi'] === 'false'); //use the new api unless the experiment is specifically turned off
      var isImageSizeAvailable = !this.isDimensionless;
      // const isSSR = !(window && window.document) || window.isMock; //the image client lib can only be used in the client (dahh)
      var hasWatermark = !!this.watermark;

      return isImageSizeAvailable && isSdkExperimentOn && !hasWatermark;
    }
  }, {
    key: 'resizeUrlImp',
    value: function resizeUrlImp(originalUrl, resizeMethod, requiredWidth, requiredHeight, sharpParams) {
      var faces = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
      var allowWatermark = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
      var focalPoint = arguments[7];
      var forceManual = arguments[8];

      if (forceManual !== true && this.useImageClientApi()) {
        return this.resizeUrlImp_sdk(originalUrl, resizeMethod, requiredWidth, requiredHeight, sharpParams, faces, allowWatermark, focalPoint);
      } else {
        return this.resizeUrlImp_manual(originalUrl, resizeMethod, requiredWidth, requiredHeight, sharpParams, faces, allowWatermark, focalPoint);
      }
    }
  }, {
    key: 'prefixUrlIfNeeded',
    value: function prefixUrlIfNeeded(originalUrl) {
      if (_index2.default.isExternalUrl(originalUrl)) {
        return originalUrl;
      } else {
        //todo remove when supporting focal point
        return 'https://static.wixstatic.com/media/' + originalUrl;
      }
    }
  }, {
    key: 'resizeUrlImp_manual',
    value: function resizeUrlImp_manual(originalUrl, resizeMethod, requiredWidth, requiredHeight, sharpParams) {
      var faces = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
      var allowWatermark = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
      var focalPoint = arguments[7];


      requiredWidth = Math.ceil(requiredWidth);
      requiredHeight = Math.ceil(requiredHeight);

      var requiredRatio = requiredWidth / requiredHeight;
      var showWatermark = allowWatermark && this.watermarkStr;

      // assign sharp default parameters
      sharpParams = sharpParams || {};

      // calc default quality
      if (!sharpParams.quality) {
        sharpParams.quality = 90;
      }

      //don't allow quality above 90 till we have proper UI indication
      sharpParams.quality = Math.min(90, sharpParams.quality);

      if (sharpParams.allowUsm === true) {
        sharpParams.usm.usm_a = Math.min(5, Math.max(0, sharpParams.usm.usm_a || 0));
        sharpParams.usm.usm_r = Math.min(128, Math.max(0, sharpParams.usm.usm_r || 0)); //should be max 500 - but it's returning a 404
        sharpParams.usm.usm_t = Math.min(1, Math.max(0, sharpParams.usm.usm_t || 0));
      }

      var focalPointObj = { x: 50, y: 50 };
      if (focalPoint && focalPoint[0] >= 0 && focalPoint[1] >= 0) {
        focalPointObj.x = Math.round(focalPoint[0] * 100);
        focalPointObj.y = Math.round(focalPoint[1] * 100);
      }

      if (_index2.default.isExternalUrl(originalUrl)) {
        return originalUrl;
      } else if (!focalPoint) {
        //todo remove when supporting focal point
        var retUrl = 'https://static.wixstatic.com/media/' + originalUrl + '/v1/' + resizeMethod + '/';
        retUrl += 'w_' + requiredWidth;
        retUrl += ',h_' + requiredHeight;
        if (resizeMethod === 'fill') {
          retUrl += ',fp_0.' + focalPointObj.x + '_0.' + focalPointObj.y;
        }
        // retUrl += ',al_' + (faces ? 'fs' : 'c');
        retUrl += ',q_' + sharpParams.quality;
        if (sharpParams.blur) {
          retUrl += ',blur_' + sharpParams.blur;
        }

        retUrl += sharpParams.usm && sharpParams.usm.usm_r ? ',usm_' + sharpParams.usm.usm_r.toFixed(2) + '_' + sharpParams.usm.usm_a.toFixed(2) + '_' + sharpParams.usm.usm_t.toFixed(2) : '';
        // Important to use this as the last param
        if (showWatermark) {
          retUrl += this.watermarkStr;
        }
        retUrl += '/' + originalUrl;
        return retUrl;
      } else {

        var scale = void 0;
        var x = void 0;
        var y = void 0;
        var orgW = void 0;
        var orgH = void 0;

        //find the scale
        if (this.ratio > requiredRatio) {
          //wide image (relative to required ratio
          scale = requiredHeight / this.maxHeight;
          orgW = Math.floor(requiredHeight * this.ratio);
          y = 0;
          x = Math.round(orgW * focalPoint[0] - requiredWidth / 2);
          x = Math.min(orgW - requiredWidth, x);
          x = Math.max(0, x);
        } else {
          //narrow image

          scale = requiredWidth / this.maxWidth;
          orgH = Math.floor(requiredWidth / this.ratio);
          x = 0;
          y = Math.round(orgH * focalPoint[1] - requiredHeight / 2);
          y = Math.min(orgH - requiredHeight, y);
          y = Math.max(0, y);
        }

        //make sure scale is not lower than needed
        //scale must be higher to prevent cases that there will be white margins (or 404)
        scale = Math.ceil(scale * 100) / 100;

        var _retUrl = 'https://static.wixstatic.com/media/' + originalUrl + '/v1/crop/';
        _retUrl += 'w_' + requiredWidth;
        _retUrl += ',h_' + requiredHeight;
        _retUrl += ',x_' + x;
        _retUrl += ',y_' + y;
        _retUrl += ',scl_' + scale.toFixed(2);
        _retUrl += ',q_' + sharpParams.quality;
        if (sharpParams.blur) {
          _retUrl += ',blur_' + sharpParams.blur;
        }
        _retUrl += sharpParams.usm && sharpParams.usm.usm_r ? ',usm_' + sharpParams.usm.usm_r.toFixed(2) + '_' + sharpParams.usm.usm_a.toFixed(2) + '_' + sharpParams.usm.usm_t.toFixed(2) : '';
        // Important to use this as the last param
        if (showWatermark) {
          _retUrl += this.watermarkStr;
        }
        _retUrl += '/' + originalUrl;
        return _retUrl;
      }
    }
  }, {
    key: 'resizeUrlImp_sdk',
    value: function resizeUrlImp_sdk(originalUrl, resizeMethod, requiredWidth, requiredHeight, sharpParams) {
      var faces = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
      var allowWatermark = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
      var focalPoint = arguments[7];


      // assign default parameters
      originalUrl = originalUrl || '';
      sharpParams = sharpParams || {};

      // calc default quality
      if (sharpParams.quality > 0) {
        //don't allow quality above 90 till we have proper UI indication
        sharpParams.quality = Math.min(90, sharpParams.quality);
      }

      var focalPointObj = { x: 50, y: 50 };
      if (focalPoint && focalPoint[0] >= 0 && focalPoint[1] >= 0) {
        focalPointObj.x = Math.round(focalPoint[0] * 100);
        focalPointObj.y = Math.round(focalPoint[1] * 100);
      }

      if (sharpParams.allowUsm === true && sharpParams.usm) {
        sharpParams.usm.usm_a = Math.min(5, Math.max(0, sharpParams.usm.usm_a || 0));
        sharpParams.usm.usm_r = Math.min(128, Math.max(0, sharpParams.usm.usm_r || 0)); //should be max 500 - but it's returning a 404
        sharpParams.usm.usm_t = Math.min(1, Math.max(0, sharpParams.usm.usm_t || 0));
      } else {
        sharpParams.usm = {
          usm_a: 0,
          usm_r: 0,
          usm_t: 0
        };
      }

      if (_index2.default.isExternalUrl(originalUrl)) {
        return originalUrl;
      } else {

        var resizer = _lodash2.default.noop;
        if (resizeMethod === 'fit') {
          // function getScaleToFitImageURL(relativeUrl, sourceWidth, sourceHeight, targetWidth, targetHeight, options) {
          resizer = imageSdk.getScaleToFitImageURL;
        } else {
          // function getScaleToFillImageURL(relativeUrl, sourceWidth, sourceHeight, targetWidth, targetHeight, options) {
          resizer = imageSdk.getScaleToFillImageURL;
        }

        /**
         * the transform options
         * @typedef  {object}   ImageTransformOptions
         * @property {boolean}  [progressive]               image transform progressive
         * @property {number}   [quality]                   image transform quality
         * @property {string}   [watermark]                 image watermark id
         * @property {object}   [unsharpMask]               unsharpMask filter
         * @property {number}   [unsharpMask.radius]        unsharpMask radius
         * @property {number}   [unsharpMask.amount]        unsharpMask amount
         * @property {number}   [unsharpMask.threshold]     unsharpMask threshold
         */

        var options = {};
        if (sharpParams.quality > 0) {
          options.quality = sharpParams.quality;
        }
        if (sharpParams.blur > 0) {
          options.filters = {
            blur: sharpParams.blur
          };
        }
        if (focalPointObj) {
          options.focalPoint = focalPointObj;
        }
        if (sharpParams && sharpParams.usm) {
          options.unsharpMask = {
            radius: parseFloat(sharpParams.usm.usm_r),
            amount: parseFloat(sharpParams.usm.usm_a),
            threshold: parseFloat(sharpParams.usm.usm_t)
          };
        }
        if (this.watermarkStrSdk) {
          options.watermark = this.watermarkStrSdk;
        }

        var prefix = '';
        if (originalUrl.indexOf('/') < 0) {
          prefix = 'media/';
        }

        var retUrl = resizer(prefix + originalUrl, this.maxWidth, this.maxHeight, requiredWidth, requiredHeight, options);

        /*
            console.log('USING THE CLIENT IMAGE SDK! Resized the image: ', retUrl, 'Previuos url was: ', this.resizeUrlImp_manual(originalUrl, resizeMethod, requiredWidth, requiredHeight, sharpParams, faces, allowWatermark, focalPoint), 'parameters were: ', {
              originalUrl,
              resizeMethod,
              orgWidth: this.maxWidth,
              orgHeight: this.maxHeight,
              requiredWidth,
              requiredHeight,
              options
            });
        	*/
        return retUrl;
      }
    }
  }, {
    key: 'createUrls',
    value: function createUrls() {
      var devicePixelRatio = this.useImageClientApi() ? 1 : _index2.default.getDevicePixelRatio(); // when using ImageClientAPI the devicePixelRatio is added automatically
      var maxWidth = this.maxWidth || this.dto.width || this.metadata.width;
      var maxHeight = this.maxHeight || this.dto.height || this.metadata.height;
      // const maxWidth = this.cubeImages ? Math.min(this.maxWidth, this.maxHeight) : this.maxWidth;
      // const maxHeight = this.cubeImages ? Math.min(this.maxWidth, this.maxHeight) : this.maxHeight;
      this.resizeWidth = Math.min(maxWidth, Math.ceil(this.width * devicePixelRatio));
      this.resizeHeight = Math.min(maxHeight, Math.ceil(this.height * devicePixelRatio));
      this.resized_url = this.resizedUrl(this.cubeType, this.resizeWidth, this.resizeHeight, this.sharpParams, false);

      this.pixel_url = this.resizedUrl('fill', 1, 1, { quality: 5 }, false);

      var maxDimension = 500;
      this.thumbnailWidth = Math.min(maxWidth, this.width, maxDimension);
      this.thumbnailHeight = Math.min(maxHeight, this.height, maxDimension);
      this.thumbnail_url = this.resizedUrl('fit', this.thumbnailWidth, this.thumbnailHeight, { quality: 30 }, false);
      this.square_url = this.resizedUrl('fill', 100, 100, { quality: 80 }, false);
      this.full_url = this.resizedUrl(this.cubeType, this.maxWidth, this.maxHeight, this.sharpParams, false);
      this.sample_url = this.resizedUrl('fit', 500, 500, this.sharpParams, false, true);
      this.download_url = _index2.default.isStoreGallery() ? this.sample_url : { img: this.getOriginalsUrl(), mp4: this.full_url.mp4 };
      if (this.download_url.img) {
        this.download_url.img += '?dn=' + this.fileName; //https://jira.wixpress.com/browse/PHOT-129#
      }
      this.preload_url = this.prefixUrlIfNeeded(this.url);
    }
  }, {
    key: 'resizedUrl',
    value: function resizedUrl(resizeMethod, requiredWidth, requiredHeight, sharpParams, showFaces, noCrop) {

      if (this.isText) {
        return {};
      }

      requiredWidth = Math.ceil(requiredWidth);
      requiredHeight = Math.ceil(requiredHeight);
      var thumbSize = 250;

      var urls = {};

      if (this.metadata.posters || this.metadata.customPoster) {
        var maxHeight = 720;
        var qualities = this.metadata.qualities;
        var poster = this.metadata.customPoster || (this.metadata.posters ? this.metadata.posters[this.metadata.posters.length - 1] : null);
        if (poster) {
          if (qualities && qualities.length) {
            var suffix = '/';

            var mp4Qualities = qualities.filter(function (video) {
              return video.formats[0] === 'mp4';
            });
            //search for the first quality bigger that the required one
            for (var quality, q = 0; quality = mp4Qualities[q]; q++) {
              if (quality.height >= requiredHeight || quality.height >= maxHeight || !mp4Qualities[q + 1]) {
                suffix += quality.quality; //e.g. 720p
                for (var format, i = 0; format = quality.formats[i]; i++) {
                  urls[format] = _windowWrapper2.default.location.protocol + '//video.wixstatic.com/video/' + this.url + suffix + '/' + format + '/file.' + format;
                }
                break;
              }
            }
            // const wixQualities = qualities.filter(video => video.formats[0] === 'wix');
            // urls.wix = window.location.protocol + '//video.wixstatic.com/video/' + this.url + suffix + '/' + format + '/file.' + format;

            var ratio = poster.width / poster.height;
            var isWider = ratio > 1;
            if (isWider) {
              requiredWidth = Math.ceil(requiredHeight * ratio);
            } else {
              requiredHeight = Math.ceil(requiredWidth / ratio);
            }
          }

          urls.img = this.resizeUrlImp(poster.url, resizeMethod, requiredWidth, requiredHeight, sharpParams, showFaces, false);
          urls.thumb = this.resizeUrlImp(poster.url, resizeMethod, thumbSize, thumbSize * requiredHeight / requiredWidth, (0, _extends3.default)({}, sharpParams, { quality: 70, blur: 30 }), false, false, true);
        }
      } else {
        var fp = noCrop !== true && this.isCropped && this.focalPoint;
        urls.img = this.resizeUrlImp(this.url, resizeMethod, requiredWidth, requiredHeight, sharpParams, showFaces, true, fp);
        urls.thumb = this.resizeUrlImp(this.url, resizeMethod, thumbSize, thumbSize * requiredHeight / requiredWidth, (0, _extends3.default)({}, sharpParams, { quality: 70, blur: 30 }), showFaces, true, fp, true);
      }

      // if (window.isWebpSupported && !utils.isStoreGallery()) {
      //   urls.thumb = urls.thumb.replace(/\.jpg$/i, '.webp');
      //   urls.img = urls.img.replace(/\.jpg$/i, '.webp');
      // }

      return urls;
    }
  }, {
    key: 'getOriginalsUrl',
    value: function getOriginalsUrl() {
      return 'https://static.wixstatic.com/media/' + this.url;
    }
  }, {
    key: 'updateSharpParams',
    value: function updateSharpParams() {
      //override sharpParams with item sharpParams
      if (this.dto.metaData && this.dto.metaData.sharpParams && this.dto.metaData.sharpParams.L) {
        var sharpParams = this.dto.metaData.sharpParams.L;
        if (sharpParams.quality && sharpParams.overrideQuality === true) {
          this.sharpParams.quality = sharpParams.quality;
        }

        if (sharpParams.usm && sharpParams.overrideUsm === true) {
          this.sharpParams.usm = sharpParams.usm;
        }
      }
    }
  }, {
    key: 'updateId',
    value: function updateId(id) {
      this.dto.itemId = this.id = id;
    }
  }, {
    key: 'updateOrderIndex',
    value: function updateOrderIndex(value) {
      var ret = this.orderIndex !== value;
      this.orderIndex = value;
      return ret;
    }
  }, {
    key: 'itemId',
    get: function get() {
      return this.id;
    }
  }, {
    key: 'metadata',
    get: function get() {
      var md = this.dto.metaData || this.dto.metadata;
      if (_lodash2.default.isUndefined(md)) {
        // console.error('Item with no metadata' + JSON.stringify(this.dto));
        md = {};
      }
      return md;
    }
  }, {
    key: 'metaData',
    get: function get() {
      return this.metadata;
    }
  }, {
    key: 'bgColor',
    get: function get() {
      var bg = void 0;
      if (this.isText) {
        bg = this.metadata && this.metadata.textStyle && this.metadata.textStyle.backgroundColor;
      } else {
        bg = 'none';
      }
      return bg;
    }
  }, {
    key: 'isCropped',
    get: function get() {
      return this.cubeImages && this.cubeType === 'fill';
    }
  }, {
    key: 'focalPoint',
    get: function get() {
      return this.metadata.focalPoint || [0.5, 0.5];
    },
    set: function set(value) {
      this.metadata.focalPoint = value;
    }

    //----------------------------------------------------------------//

  }, {
    key: 'demoTitle',
    get: function get() {
      return 'I am a title, only a sample title but still a title. ';
    }
  }, {
    key: 'demoDescription',
    get: function get() {
      return 'I am a description, the best description ever! Here is some lorem ipsum for you: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.';
    }
  }, {
    key: 'demoExif',
    get: function get() {
      return {
        GPSVersionID: '2.2.0.0',
        GPSAltitudeRef: '1.8',
        GPSAltitude: '0',
        Make: 'LG Electronics',
        Model: 'LG-H815L',
        Orientation: 'right-top',
        XResolution: '72',
        YResolution: '72',
        ResolutionUnit: '2',
        Software: 'Picasa',
        DateTime: '2016:04:17 07:19:25',
        YCbCrPositioning: '1',
        ExposureTime: '0.041666666666666664',
        FNumber: '1.8',
        ExifIFDPointer: '214',
        ExposureProgram: 'Undefined',
        GPSInfoIFDPointer: '1262',
        PhotographicSensitivity: '200',
        ExifVersion: '0220',
        DateTimeOriginal: '2016:04:17 07:19:25',
        DateTimeDigitized: '2016:04:17 07:19:25',
        ComponentsConfiguration: 'YCbCr',
        ShutterSpeedValue: '4.585',
        ApertureValue: '1.69',
        BrightnessValue: '-0.88',
        ExposureBias: '0',
        MeteringMode: 'CenterWeightedAverage',
        Flash: 'Flash did not fire, compulsory flash mode',
        FocalLength: '4.42',
        UserComment: '32,32,32,70,77,49,32,32,32,70,67,48,48,48,48,48,48,48,48,48,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0',
        SubSecTime: '802528',
        SubSecTimeOriginal: '802528',
        SubSecTimeDigitized: '802528',
        FlashpixVersion: '0100',
        ColorSpace: '1',
        PixelXDimension: '5312',
        PixelYDimension: '2988',
        InteroperabilityIFDPointer: '1320',
        SensingMethod: 'Undefined',
        SceneType: 'Directly photographed',
        ExposureMode: '0',
        WhiteBalance: 'Auto white balance',
        DigitalZoomRatio: '1',
        SceneCaptureType: 'Standard',
        ImageUniqueID: '36f6e92221e27c830000000000000000'
      };
    }
  }, {
    key: 'photoId',
    get: function get() {
      return this.id;
    }
  }, {
    key: 'key',
    get: function get() {
      if (!this._key) {
        this._key = (this.dto.key || this.id || this.dto.url || 'no_key_found').replace(/\W/g, '');
      }
      return this._key;
    }
  }, {
    key: 'orderIndex',
    get: function get() {
      return this.dto.orderIndex || this.dto.o || 0;
    },
    set: function set(value) {
      this.dto.orderIndex = value;
    }
  }, {
    key: 'name',
    get: function get() {
      return this.metadata.fileName || '';
    }
  }, {
    key: 'url',
    get: function get() {
      //todo :change from mediaUrl
      return this.dto.file_url || this.dto.mediaUrl || this.dto.url || this.dto.src;
    }
  }, {
    key: 'mediaUrl',
    get: function get() {
      return this.url;
    }
  }, {
    key: 'html',
    get: function get() {
      return this.dto.html || this.dto.text || this.metadata.html || this.metadata.text;
    }
  }, {
    key: 'lastModified',
    get: function get() {
      return this.metadata.lastModified;
    }
  }, {
    key: 'seed',
    get: function get() {
      return _index2.default.hashToInt(this.url);
    }
  }, {
    key: 'isImage',
    get: function get() {
      return this.type === 'image';
    }
  }, {
    key: 'isImportant',
    get: function get() {
      return !!this.dto.i;
    }
  }, {
    key: 'isVideo',
    get: function get() {
      return this.type === 'video';
    }
  }, {
    key: 'videoUrl',
    get: function get() {
      return this.metadata.videoUrl;
    }
  }, {
    key: 'isExternalVideo',
    get: function get() {
      return this.metadata.isExternal;
    }
  }, {
    key: 'isExternal',
    get: function get() {
      return this.metadata.isExternal === true;
    }
  }, {
    key: 'type',
    set: function set(type) {
      this._type = type;
    },
    get: function get() {
      switch (this._type || this.dto.type || this.metadata.type || this.dto.media_type) {
        case 'dummy':
          return 'dummy';
        case 'v':
        case 'video':
          return 'video';
        case 'h':
        case 'html':
        case 'text':
          return 'text';
        case 'i':
        case 'image':
        default:
          return 'image';
      }
    }
  }, {
    key: 'alt',
    get: function get() {
      return this.metadata.alt || this.title || this.description;
    }
  }, {
    key: 'title',
    get: function get() {
      var title = this.metadata.title;
      if (typeof title === 'string') {
        return title;
      } else {
        var filename = this.metadata.fileName;
        if (filename) return filename;
      }
      return '';
      // if (!this.metadata.isDemo) {
      //   return this.metadata.title || '';
      // }
      // return this.getTranslatedValue(this.metadata.title);
    },
    set: function set(value) {
      this.metadata.title = value;
    }
  }, {
    key: 'fileName',
    get: function get() {
      return this.metadata.fileName || '';
    },
    set: function set(value) {
      this.metadata.fileName = value;
    }
  }, {
    key: 'description',
    get: function get() {
      return this.metadata.description || '';
      // if (!this.metadata.isDemo) {
      //   return this.metadata.description || '';
      // }
      // return this.getTranslatedValue(this.metadata.description);
    },
    set: function set(value) {
      this.metadata.description = value;
    }
  }, {
    key: 'exif',
    get: function get() {
      return this.metadata.exif || '';
    }
  }, {
    key: 'hasLink',
    get: function get() {
      switch (this.linkType) {
        case 'wix':
          return !!this.linkData.type;
        default:
          return !!this.linkUrl;
      }
    }
  }, {
    key: 'link',
    get: function get() {
      return this.metadata.link || {};
    }
  }, {
    key: 'linkData',
    get: function get() {
      if (this.metadata.link) {
        return this.metadata.link.data || {};
      }
    },
    set: function set(value) {
      if (!this.metadata.link) {
        this.metadata.link = {};
      }
      this.metadata.link.data = value;
    }
  }, {
    key: 'linkType',
    get: function get() {
      if (this.metadata.link && !_lodash2.default.isUndefined(this.metadata.link.type)) {
        return this.metadata.link.type;
      } else if (this.linkUrl) {
        return 'web';
      } else {
        return 'none';
      }
    },
    set: function set(value) {
      if (!this.metadata.link) {
        this.metadata.link = {};
      }

      // reset metadata.link when 'none' is selected - that's the way wix galleries work
      this.metadata.link = {
        type: value,
        url: undefined,
        text: undefined,
        title: undefined,
        target: '_blank'
      };
    }
  }, {
    key: 'defaultLinkText',
    get: function get() {
      var linkData = this.linkData;

      switch (this.linkType) {
        case 'wix':
          if (linkData) {
            switch (linkData.type) {
              case 'PageLink':
                return 'Go to Page ' + linkData.pageName;
              case 'AnchorLink':
                return 'Scroll to ' + linkData.anchorName;
              case 'ExternalLink':
                return '' + linkData.url;
              case 'EmailLink':
                return 'Email ' + linkData.recipient;
              case 'PhoneLink':
                return 'Call ' + linkData.phoneNumber;
              case 'DocumentLink':
                return 'Open ' + linkData.name;
              default:
                return 'Go to Link';
            }
          } else {
            return 'Go to Link';
          }
        case 'web':
          return this.linkUrl;
        case 'page':
          return this.linkTitle;
        default:
          return '';
      }
      /*
          const wixLinkDataSamples = {
            page: {
              pageId: "#c1dmp",
              type: "PageLink"
            },
            anchor: {
              anchorDataId: "",
              anchorName: "Anchor 1",
              pageId: "#masterPage",
              type: "AnchorLink"
            },
            web: {
              target: "_self",
              type: "ExternalLink",
              url: "http://google.com"
            },
            email: {
              recipient: "guyso@wix.com",
              subject: "subject",
              type: "EmailLink"
            },
            phone: {
              phoneNumber: "0547787444",
              type: "PhoneLink"
            },
            document: {
              docId: "0d72ac_7395fddc29a84899a472b5fcf0dee3ed.doc",
              name: "חוזה-שכירות-משנה-בלתי-מוגנת.doc",
              type: "DocumentLink"
            },
            scroll: {
              anchorDataId: "SCROLL_TO_TOP",
              anchorName: "Top of Page",
              pageId: "#masterPage",
              type: "AnchorLink"
            },
            lightbox: {
              pageId: "#zwjzg",
              type: "PageLink"
            }
           }
      */
    }
  }, {
    key: 'defaultLinkValue',
    get: function get() {
      var linkData = this.linkData;

      switch (this.linkType) {
        case 'wix':
          if (linkData) {
            switch (linkData.type) {
              case 'PageLink':
                if (linkData.pageName) {
                  return 'PAGE - ' + linkData.pageName;
                } else {
                  return 'PAGE';
                }
              case 'AnchorLink':
                return 'ANCHOR - ' + linkData.anchorName;
              case 'ExternalLink':
                return 'LINK - ' + linkData.url;
              case 'EmailLink':
                return 'EMAIL - ' + linkData.recipient;
              case 'PhoneLink':
                return 'PHONE - ' + linkData.phoneNumber;
              case 'DocumentLink':
                return 'DOCUMENT - ' + linkData.name;
              default:
                return 'Add a Link';
            }
          } else {
            return 'Add a Link';
          }
        case 'web':
          return this.linkUrl;
        case 'page':
          return this.linkTitle;
        default:
          return '';
      }
    }
  }, {
    key: 'linkText',
    get: function get() {
      if (this.metadata.link) {
        return this.metadata.link.text || this.defaultLinkText;
      }
    },
    set: function set(value) {
      if (!this.metadata.link) {
        this.metadata.link = {};
      }
      this.metadata.link.text = value;
    }
  }, {
    key: 'linkTitle',
    get: function get() {
      if (this.metadata.link) {
        return this.metadata.link.title;
      }
    },
    set: function set(value) {
      if (!this.metadata.link) {
        this.metadata.link = {};
      }
      this.metadata.link.title = value;
    }
  }, {
    key: 'linkUrl',
    get: function get() {
      if (this.metadata.link) {
        return this.metadata.link.url;
      }
    },
    set: function set(value) {
      if (!this.metadata.link) {
        this.metadata.link = {};
      }
      this.metadata.link.url = value;
    }
  }, {
    key: 'unprotectedLinkOpenType',
    get: function get() {
      return _lodash2.default.get(this, 'metadata.link.target');
    }
  }, {
    key: 'linkOpenType',
    get: function get() {
      if (_index2.default.isEditor() || _index2.default.isPreview()) {
        //in preview never open link in current window (causes many errors)
        return '_blank';
      } else if (this.metadata.link && !_lodash2.default.isUndefined(this.metadata.link.target)) {
        return this.unprotectedLinkOpenType;
      } else if (this.metadata.link && !_lodash2.default.isUndefined(this.metadata.link.targetBlank)) {
        return this.metadata.link.targetBlank ? '_blank' : '_top';
      } else {
        return '_blank';
      }
    },
    set: function set(value) {
      if (!this.metadata.link) {
        this.metadata.link = {};
      }
      this.metadata.link.target = value;
    }
  }, {
    key: 'initialLinkObject',
    get: function get() {
      return {
        type: 'none',
        url: undefined,
        text: undefined,
        title: undefined,
        target: '_blank'
      };
    }
  }, {
    key: 'isDemo',
    get: function get() {
      return this.metadata.isDemo || this.dto.isDemo || this.metadata.sourceName === 'public' || _lodash2.default.includes(this.metadata.tags, '_paid');
    },
    set: function set(val) {
      this.metadata.isDemo = val;
    }
  }, {
    key: 'isText',
    get: function get() {
      return this.type === 'text';
    }
  }, {
    key: 'isVisible',
    get: function get() {
      return this.visibility && this.visibility.visible;
    }
  }, {
    key: 'isRendered',
    get: function get() {
      return this.visibility && this.visibility.rendered;
    }
  }, {
    key: 'isDimensionless',
    get: function get() {
      return !(this.maxWidth > 1 || this.maxHeight > 1);
    }
  }, {
    key: 'isTransparent',
    get: function get() {
      return this.url && (this.url.indexOf('.png') > 0 || this.url.indexOf('.gif') > 0);
    }
  }, {
    key: 'directLink',
    get: function get() {
      return this.dto.directLink || '';
    }
  }]);
  return GalleryItem;
}();

/*
 <img onLoad={() => this.setItemLoaded()} className={'image' + (this.state.loaded ? '' : '-preload')}
 src={this.props.resized_url}/>
 */

////// <reference path="../../reference.ts" />


exports.default = GalleryItem;